"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mountWithRouterAndThemeProvider = exports.getProp = void 0;
exports.mountWithTheme = mountWithTheme;
exports.shallowMountWithThemeAndRouter = exports.setupEnzymeAdapter = exports.mountWithThemeProvider = void 0;
exports.shallowWithTheme = shallowWithTheme;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _config = _interopRequireDefault(require("@trs/config"));
var _styledComponents = require("styled-components");
var _reactRouter = require("react-router");
var _enzymeAdapterReact = _interopRequireDefault(require("@wojtekmaj/enzyme-adapter-react-17"));
var _enzyme = _interopRequireWildcard(require("enzyme"));
var _objects = require("../objects");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var theme = _config["default"].theme;
var setupEnzymeAdapter = function setupEnzymeAdapter() {
  _enzyme["default"].configure({
    adapter: new _enzymeAdapterReact["default"]()
  });
};
exports.setupEnzymeAdapter = setupEnzymeAdapter;
var mountWithThemeProvider = function mountWithThemeProvider(children) {
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme.base
  }, children);
};
exports.mountWithThemeProvider = mountWithThemeProvider;
var mountWithRouterAndThemeProvider = function mountWithRouterAndThemeProvider(children) {
  return (
    // eslint-disable-next-line react/prop-types
    function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$routeEntries = _ref.routeEntries,
        routeEntries = _ref$routeEntries === void 0 ? ['/'] : _ref$routeEntries;
      return /*#__PURE__*/_react["default"].createElement(_reactRouter.MemoryRouter, {
        initialEntries: routeEntries
      }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme.base
      }, children));
    }
  );
};

/* eslint-disable */
exports.mountWithRouterAndThemeProvider = mountWithRouterAndThemeProvider;
function mountWithTheme(child) {
  return (0, _enzyme.mount)(child, {
    // eslint-disable-next-line react/prop-types
    wrappingComponent: function wrappingComponent(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme.base
      }, children);
    }
  });
}
function shallowWithTheme(child) {
  return (0, _enzyme.shallow)(child, {
    // eslint-disable-next-line react/prop-types
    wrappingComponent: function wrappingComponent(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme.base
      }, children);
    }
  });
}
var shallowMountWithThemeAndRouter = function shallowMountWithThemeAndRouter(tree) {
  var context = (0, _enzyme.shallow)( /*#__PURE__*/_react["default"].createElement(_reactRouter.MemoryRouter, {
    initialEntries: ['/random']
  })).instance().context.context;
  context = R.path(['context'], (0, _enzyme.shallow)( /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme.base
  }), {
    context: context
  }).instance());
  return (0, _enzyme.shallow)(tree, {
    context: context,
    childContextTypes: _styledComponents.ThemeProvider.childContextTypes // Needed so child components receive the theme prop
  });
};
/* eslint-disable */
exports.shallowMountWithThemeAndRouter = shallowMountWithThemeAndRouter;
var getProp = function getProp(wrapper, selector, prop) {
  if (!wrapper) return null;
  var node = selector ? wrapper.find(selector) : wrapper;
  if ((0, _objects.isBlank)(node) || !R.prop('props', node)) return null; // no selector found
  if (!prop) return node.props(); // return all props if no prop name
  return R.prop(prop, node.props());
};
exports.getProp = getProp;
mountWithThemeProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "mountWithThemeProvider"
};